"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SearchResult;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _siteSearchContext = require("../site-search-context");
var _text = _interopRequireDefault(require("@ux/text"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Wrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Wrapper",
  class: "pl-w12bsjuf",
  vars: {
    "w12bsjuf-3": [({
      selected
    }) => selected ? `${_intents.default.ux.figure.figureColor4}` : `${_intents.default.ux.actionPrimary.backgroundColor}`]
  }
});
const Headline = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "Headline",
  class: "pl-hby1gpe"
});
const SuggestionButton = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "SuggestionButton",
  class: "pl-smfz746"
});
function SearchResult({
  id,
  title,
  headline,
  description,
  url,
  style,
  trackingCustomProperties = {},
  trackingEid = null
}) {
  const {
    value,
    handleOnConfirm,
    highlightKeyword,
    resultsExternalPaths,
    step
  } = (0, _react.useContext)(_siteSearchContext.SiteSearchContext);
  const trackingProps = _patternLibraryUtils.tracking.create(trackingEid ?? `${step}_${id}_${title}`, true, false, trackingCustomProperties);
  const externalPaths = resultsExternalPaths?.split(',')?.map(path => path.trim());
  const urlTarget = externalPaths?.some(path => url?.includes(path)) ? '_blank' : '_self';
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    "data-cy": "result",
    style: style
  }, step === 'results' ? /*#__PURE__*/_react.default.createElement(Headline, (0, _extends2.default)({
    href: url,
    target: urlTarget
  }, trackingProps), /*#__PURE__*/_react.default.createElement(_text.default.span, {
    as: "title",
    size: 1,
    className: "headlineTitle"
  }, title, " ", headline && /*#__PURE__*/_react.default.createElement("span", {
    "data-cy": "r-headline"
  }, "| ", headline)), description && /*#__PURE__*/_react.default.createElement("p", null, description)) : /*#__PURE__*/_react.default.createElement(SuggestionButton, (0, _extends2.default)({
    className: "ux-button ux-button-inline",
    "data-step": step,
    onClick: () => handleOnConfirm(title)
  }, trackingProps), step === 'suggestions' ? highlightKeyword(title, value) : title));
}
SearchResult.propTypes = {
  id: _propTypes.default.string,
  title: _propTypes.default.string,
  headline: _propTypes.default.string,
  description: _propTypes.default.string,
  url: _propTypes.default.string,
  breadcrumbs: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  style: _propTypes.default.object,
  trackingCustomProperties: _propTypes.default.object,
  trackingEid: _propTypes.default.string
};